import type { CSSProperties } from "react";
export type MascotMood =
  | "idle"
  | "walk"
  | "sit"
  | "sleep"
  | "scan"
  | "buy"
  | "watch"
  | "avoid"
  | "cheer";
const positions: Record<MascotMood, string> = {
  idle: "50% 0%",
  walk: "0% 0%",
  sit: "100% 0%",
  sleep: "0% 50%",
  scan: "50% 50%",
  buy: "100% 50%",
  watch: "0% 100%",
  avoid: "50% 100%",
  cheer: "100% 100%",
};
interface MascotProps {
  mood: MascotMood;
  size?: "small" | "medium" | "large";
  coin?: boolean;
  label?: string;
}
export function Mascot({
  mood,
  size = "medium",
  coin = false,
  label,
}: MascotProps) {
  const style = { "--sprite-position": positions[mood] } as CSSProperties;
  return (
    <div className={`mascot mascot--${size}`} data-mood={mood} style={style}>
      <span
        className="mascot__sprite"
        role="img"
        aria-label={label ?? `Mascot is ${mood}`}
      />
      {coin ? (
        <span className="mascot__coin" aria-hidden="true">
          ◎
        </span>
      ) : null}
    </div>
  );
}
